import AjaxSpinner from '../../../../src/components/AjaxSpinner';
import React from 'react';
import styled from 'styled-components';
import { TrevorIcon } from '../TrevorIcon';

const LoadingContainer = styled.div``;

export const Loading = () => {
  return (
    <LoadingContainer>
      {/*TODO: Loading spinner should be defined here*/}
      <AjaxSpinner
        // @ts-ignore
        center
      />
    </LoadingContainer>
  );
};

export const LoadingSpinnerCenter = styled(TrevorIcon).attrs({
  name: 'spinner',
})`
  position: absolute;
  animation: loading 3s linear infinite;
  color: var(--color-interface-secondary-normal);
  visibility: visible !important;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;

  @keyframes loading {
    from {
      rotate: z 0deg;
    }
    to {
      rotate: z 360deg;
    }
  }
`;
